/**
 * The Import source menu's sections (Option C final UX review UX-17): the sources found on this computer first, then
 * the rest in three groups — Apps (the other tools' own settings), Files (export and configuration files) and Azure —
 * instead of one flat list of sixteen. A source is listed once; an empty group is left out. Registry order within each.
 */
import type { ImportSourceId } from '../../../types/connectionImport';
import { IMPORT_SOURCES, type ImportSourceGroup, type ImportSourceMeta } from './connectionImportSources';

export type ImportSourceSection = { id: 'found' | ImportSourceGroup; label: string; sources: ImportSourceMeta[] };

const GROUPS: Array<{ id: ImportSourceGroup; label: string }> = [
  { id: 'apps', label: 'Apps' },
  { id: 'files', label: 'Files' },
  { id: 'azure', label: 'Azure' },
];

export function importSourceGroups(detected: ReadonlySet<ImportSourceId>): ImportSourceSection[] {
  const found = IMPORT_SOURCES.filter((source) => detected.has(source.id));
  const sections: ImportSourceSection[] = found.length > 0 ? [{ id: 'found', label: 'Found on this computer', sources: found }] : [];
  for (const group of GROUPS) {
    const sources = IMPORT_SOURCES.filter((source) => source.group === group.id && !detected.has(source.id));
    if (sources.length > 0) sections.push({ ...group, sources });
  }
  return sections;
}
